const DriverStatus = {
  Active: "active",
  Inactive: "inactive",
};

export default DriverStatus;
